import { render } from "./SwipeItem.vue?vue&type=template&id=2d288fdc"
import script from "./SwipeItem.vue?vue&type=script&lang=js"
export * from "./SwipeItem.vue?vue&type=script&lang=js"
script.render = render

export default script